module.exports = __webpack_public_path__ + "img/news2.e5eb3a17.jpg";